import { CommunityFeedPage } from '@/features/communities/CommunityFeedPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_authenticated/benefits/communities/$communityId',
)({
  component: CommunityFeedPage,
})

